// 整体效果
import React, { useState } from 'react';
import { Radio, Badge } from 'antd';
import { GraphWrapper } from '@/components/Graph';
import { overallEffectLine } from '../GraphConfig';
import styles from './index.module.less';
const renderOptions = function (comparisonItem, index) {
    return (<div>
      <p>
        <span>{`对比组${+index + 1}`}</span>
        <Badge color="#0080FF" text={`关键效果指标：${comparisonItem.crucialName}`}/>

        {comparisonItem.contrastCode && (<Badge color="#08DBA2" text={`对比指标：${comparisonItem.contrastName}`}/>)}
      </p>
    </div>);
};
export default function OverallEffect(props) {
    const { title, comparisonGroup } = props;
    const [currentComparisonGroup, setCurrentComparisonGroup] = useState(comparisonGroup[0]);
    const handleRadioChange = (e) => {
        setCurrentComparisonGroup(comparisonGroup[e.target.value]);
    };
    return (<div className={styles['overall-effect']}>
      <header>{title}</header>

      <div className={styles['overall-effect-wrapper']}>
        
        <div className={styles['overall-effect-graph']}>
          <GraphWrapper className="overall-effect-graph-wrapper" config={overallEffectLine(currentComparisonGroup, {
        hasContrast: !!currentComparisonGroup.contrastCode,
        dataType: currentComparisonGroup.dataType,
    })} height={300}/>
        </div>

        <div className={styles['select-desc-box']}>
          <div className={styles['select-list']}>
            <div className={styles['select-list-item']}>
              <Radio.Group onChange={handleRadioChange} defaultValue={0}>
                {comparisonGroup.map((comparisonItem, index) => (<Radio key={index} className={styles['select-list-item-radio']} value={index}>
                    {renderOptions(comparisonItem, index)}
                  </Radio>))}
              </Radio.Group>
            </div>
          </div>

          {currentComparisonGroup.desc && (<div className={styles['desc']}>{currentComparisonGroup.desc}</div>)}
        </div>
      </div>
    </div>);
}
